<template>
  <div class="content">
    <div :class="{bg: true, bottom: $route.query.c}">
      <div class="info">
        <div class="left">
          <div class="title">{{detail.title}}</div>
          <div class="info-container">
            <div class="info-content">
              <div class="info">
                <p>执行人</p>
                <span>{{detail.executor_name}}</span>
              </div>
              <div class="info">
                <p>所属部门</p>
                <span>{{detail.depart_name}}</span>
              </div>
            </div>
            <div class="info-content">
              <div class="info">
                <p>选题日期</p>
                <span>{{detail.date}}</span>
              </div>
            </div>
          </div>
          <div class="divider"></div>
          <div class="viceTitle">其他信息</div>
          <div class="import">
            <p>重要选题</p>
            <span>{{detail.is_important == 1 ? '是' : '否'}}</span>
          </div>
          <div class="import">
            <p>查看范围</p>
            <span>{{detail.view_scope == 1 ? '保密' : '公开'}}</span>
          </div>
          <div v-show="statusNum == 2" class="tagsContent">
            <span>值班长意见<img v-show="has_foreman_opt_role" @click="editForeman(detail)" class="edit" src="@assets/img/mediaPublish/titleEdit.png"></span>
            <p>{{detail.foreman_view}}</p>
            <div class="tags">
              <div v-for="item in foreman_issue_platform" :key="item" :class="{blue: item == '电视', purple: item == '新媒体', green: item == '直播', pink: item == '海报'}">{{item}}</div>
            </div>
          </div>
          <div class="divider"></div>
          <div class="viceTitle">关联采访<span v-show="has_interview_detail_role && statusNum == 2" @click="changeInterview = !changeInterview">{{detail.interviews && detail.interviews.length > 0 ? '修改' : '添加'}}</span></div>
          <div v-show="!changeInterview" class="interviewList">
            <p v-for="item in detail.interviews" :key="item.id" @click="toInterviewDetail(item.id)">{{item.title}}</p>
          </div>
          <div v-show="changeInterview" class="linkTopic">
            <p @click="openLink" class="linkBtn">
              <img src="@assets/img/interview/link.svg" alt="link">
              <span>{{`关联采访`}}</span>
            </p>
            <span :class="{linkMsg: true}">可关联多条采访</span>
          </div>
          <ul v-show="changeInterview" class="selectInterview">
            <!-- <li v-for="(item, index) in withInterview" :key="index">
              <p>{{item.title}}</p>
              <i></i>
            </li> -->
            <li v-for="(item,index) in detail.interviews" :key="item.id">
              <p>{{item.title}}</p>
              <i @click="delInterview(index)"></i>
            </li>
          </ul>
        </div>
        <div class="right">
          <div class="people">
            <div class="block">
              <p class="key">
                发布者
              </p>
              <p :class="{value: true, none: !publisher, card: publisher}" @click="showCard(publisherId, 0, $event)">
                {{publisher || '无'}}
              </p>
            </div>
            <div class="seperator"></div>
            <div class="block">
              <p class="key">
                审批人
              </p>
              <p :class="{value: true, none: !approver, card: approver}" @click="showCard(approverId, 0, $event)">
                {{approver || '无'}}
              </p>
            </div>
          </div>  

          <div v-show="statusNum == 2" @click="openProgressUpdate" class="progress">
            <div class="leftDom">
              <i></i>
              <span>进展更新</span>
            </div>
            <div class="rightDom"></div>
          </div>
          <div v-show="statusNum == 2" @click="openDiscussBox" class="area">
            <div class="leftDom">
              <i></i>
              <span>讨论区</span>
            </div>
            <div class="rightDom"></div>
          </div>
        </div>
      </div>
    </div>
    <withInterview :from="22" ref="withInterview" @getInterview="fetchInterview" />
    <div v-if="isCheck || isBack" class="footer">
      <div v-if="isCheck" class="btn prov" @click="handleInterviews(2)">通过</div>
      <div v-if="isCheck" class="btn disable" @click="handleInterviews(1)">退回</div>
      <div v-click-outside="hideThreeBtn" v-if="isCheck" class="threeBtn">
        <p title="更多" @click="showThreeBtn = !showThreeBtn" :class="{on: showThreeBtn}"></p>
        <div v-if="showThreeBtn" class="btn">
          <ul>
            <li @click="goEdit">编辑</li>
          </ul>
          <span></span>
        </div>
      </div>
      <div v-if="isBack" class="btn prov" @click="goEdit">编辑</div>
    </div>
  </div>
</template>

<script>
import common from '@common/common'
import { apis } from '@common/config'
import empty from '@components/empty'
import withInterview from "@components/withNewInterview";
import dc from '@common/dc'
import vClickOutside from "v-click-outside";

export default {
  name: 'interviewDetail',
  directives: {
    clickOutside: vClickOutside.directive
  },
  components: {
    empty,
    withInterview
  },
  data() {
    return {
      isBack: false,
      showThreeBtn: false,
      foreman_issue_platform: [],
      changeInterview: false,
      detail: {},
      show_receive: false,
      show_delay: false,
      show_return: false,
      expandDevice: [],
      statusNum: '',
      expand_device_task_status: '',
      back_reason: '',
      isXnew: this.$store.state.isXnew,
      title: '',
      status: '',
      dep: '',
      topic: '',
      topicId: '',
      startTime: '',
      endTime: '',
      locate: '',
      reporter: '',
      camera: '',
      driver: '',
      bus: '',
      remark: '',
      publisher: '',
      approver: '',
      handler: '',
      publisherId: '',
      approverId: '',
      handlerId: '',
      expandhandler: '',
      expandhandlerId: '',
      equipments: [],
      uploads: [],
      defaultImg: require('@assets/img/common/default.png'),
      showHistory: false,
      interviewHistory: [],
      showUpload: false,
      topicDeleted: false,
      isCheck: false, // 是否是审核详情页
      hasClueRole: false,
      topicRole: false, // 是否有策划详情权限
      progressH: 0,
      footLineGap: 230,
      showTopic: false,
      set_device_outdate_alarm: 0,
      is_received: 0,
      has_talkarea_edit_role: false,
      has_foreman_opt_role: false,
      has_interview_detail_role: false
    }
  },
  methods: {
    hideThreeBtn() {
      this.showThreeBtn = false;
    },
    relaInterview() {
      let arr = []
      this.detail.interviews.forEach(i => {
        arr.push(i.id)
      })
      let info = {
        id: this.$route.query.r,
        interview_ids: arr.join(',')
      }

      common.myFetch(apis.newTopicRelaInterview, info).then(res => {
        if(res){

        }
      })
    },
    delInterview(index) {
      this.detail.interviews = this.detail.interviews.filter((i,key) => {
        return index != key
      })

      this.$nextTick(() => {
        this.relaInterview()
      })
    },
    toInterviewDetail(id) {
      if(this.has_interview_detail_role){
        common.jump(`/interviewDetail?r=${id}`, true);
      }else{
        this.$toast('无查看权限')
      }
    },
    openLink() {
      // 打开关联选题弹窗
      this.$refs.withInterview.open()
    },
    fetchInterview(i) {
      this.detail.interviews = (this.detail.interviews || []).concat(i)

      this.$nextTick(() => {
        this.relaInterview()
      })
      // 获取关联采访
    },
    openDiscussBox() {
      this.$discussBox({title: this.detail.title, id: this.detail.id, has_talkarea_edit_role: this.has_talkarea_edit_role}).then(res => {
        if(res){

        }
      })
    },
    openProgressUpdate() {
      this.$progressUpdate({title: this.detail.title, id: this.detail.id}).then(res => {
        if(res){

        }
      })
    },
    equipDetail(i) {
      console.log(i)
      this.$equipInfo(i)
    },
    tipsout() {
      let cardRight = document.getElementsByClassName('cardRight')[0]
      if(cardRight){
        cardRight.remove()
      }
      // console.log(999)
    },
    receive() {
      this.$InterviewCheck({
        title: '领取设备',
        type: 'noSelect',
        mode: 'get',
        id: this.$route.query.r,
        expandDevice: this.expandDevice,
        set_device_outdate_alarm: this.set_device_outdate_alarm
      }).then(res => {
        if(res){
          this.getDetail()
        }
      })
    },
    delayList() {
      const data = {
          iview_id: this.$route.query.r
      }

      common.myFetch(apis.Delaylist, data)
          .then((data) => {
            console.log(data)
            data.list.forEach(el => {
              el.content = '',
              el.date = '',
              el.selected = false
            });
            this.$InterviewCheck({
              title: '请选择需要延期归还的设备',
              type: 'select',
              mode: 'delay',
              id: this.$route.query.r,
              expandDevice: data.list
            }).then(res => {
              if(res){
                this.getDetail()
              }
            })
      })
    },
    returnList() {
      const data = {
          iview_id: this.$route.query.r
      }

      common.myFetch(apis.Return_list, data)
          .then((data) => {
            console.log(data)
            data.list.forEach(el => {
              el.content = '',
              el.url = ''
              el.name = ''
              el.uploadId = ''
              el.isUpload = false
              el.progress = true
              el.progressNum = 0
              el.selected = true
            });
            this.$InterviewCheck({
              title: '请选择需要归还的设备',
              type: 'select',
              mode: 'back',
              id: this.$route.query.r,
              expandDevice: data.list
            }).then(res => {
              if(res){
                this.getDetail()
              }
            })
          // this.$toast(data)
          // this.show = false;
          // this.callback(true)
          // console.log(data)
      })
      
    },
    showCard(id, type, e) {
      if (id == 0) return
      type = type || 0

      const el = e.target

      this.$card(id, el, type)
    },
    showCardRight(id, type, e) {
      // console.log(123)
      if (id == 0) return;
// console.log(123)
      const el = e.target;

      this.$cardRight(id, el, type);
    },
    goClueDetail(r) {
      if (!this.hasClueRole) {
        this.$toast('无访问权限')
        return
      }

      common.jump(`/clueDetail?d=${r.material_id}`, true)
    },
    toggleHistory() {
      this.showHistory = !this.showHistory

      if (this.showHistory) {
        this.$nextTick(() => {
          const container = document.querySelector('.stages')
          const stagesHeight = container.scrollHeight
          this.progressH = stagesHeight
        })
      }
    },
    checkType() {
      // 检查页面类型：详情 ／ 审核详情
      const c = this.$route.query.c
      if (c && c == 't') {
        this.isCheck = true
      }else if (c && c == 'b'){
        this.isBack = true
      }
    },
    async goEdit() {
      const id = this.$route.query.r
      const checked = await common.checkPageStatus(id, 6)
      if (!checked) return

      this.$router.push({
        path: '/newTopicEdit',
        query: {
          r: id,
          type: 'change'
        }
      })
    },
    async handleInterviews(status) {
      let msg = '确认通过吗？'
      if (status === 1) {
        msg = '确认退回吗？'
      }
      const c = await this.$confirm(msg)
      if (!c) return

      const id = this.$route.query.r
      const info = {
        ids: id,
        status: status
      }

      common.myFetch(apis.newTopicVerify, info)
        .then((data) => {
          if (data) {
            this.$toast(data)

            // window.history.go(-1)
            this.$router.push({
              path: '/newTopicAudit/xuantishenhe'
            })
          }
        })
    },
    getDetail() {
      // 获取详情数据
      const id = this.$route.query.r
      const data = {
        id: id
      }

      common.myFetch(apis.newTopicDetail, data)
        .then((data) => {
          this.matchData(data.detail)
          this.show_receive = data.show_receive
          this.show_delay = data.show_delay
          this.show_return = data.show_return
          this.expandDevice = data.expandDevice
          this.showTopic = !!data.topicExist
          this.set_device_outdate_alarm = data.set_device_outdate_alarm
          this.is_received = data.is_received
          this.has_talkarea_edit_role = data.detail.has_talkarea_edit_role
          this.has_foreman_opt_role = data.detail.has_foreman_opt_role
          this.has_interview_detail_role = data.detail.has_interview_detail_role

          this.$emit('statusChange',data.detail.status_name)
        })
    },
    editForeman(i) {
      console.log(i)
      let arr = []

      if(i.foreman_issue_platform){
        arr = i.foreman_issue_platform.split(',')
      }
      
      let info = {
        id: i.id,
        foreman_view: i.foreman_view,
        foreman_issue_platform: i.foreman_issue_platform,
        arr: arr
      }
      this.$foremanInfo(info).then(res => {
        if(res){
          this.getDetail()
        }
      })
    },
    getClues() {
      // 获取关联线索
      const info = {
        iview_id: this.$route.query.r
      }

      common.myFetch(apis.Itv_clues, info)
        .then((r) => {
          if (r) {
            this.uploads = r.list
            this.hasClueRole = r.has_material_role
          }
        })
    },
    getHistory() {
      // 获取采访的一生
      const id = this.$route.query.r
      const data = {
        iview_id: id
      }

      common.myFetch(apis.Itv_interview_history, data, 'post')
        .then((data) => {
          this.interviewHistory = data.list
        })
    },
    matchData(data) {
      // 处理详情数据，展示到页面
      if(data.foreman_issue_platform){
        this.foreman_issue_platform = data.foreman_issue_platform.split(',')
      }
      this.detail = data
      this.title = data.title
      this.dep = data.depart_name
      this.topic = data.topic_title
      this.topicId = data.topic_id
      this.startTime = data.start
      this.endTime = data.end
      this.locate = data.address
      // this.reporter = data.base_class.reporters
      // this.camera = data.base_class.cameras
      // this.driver = data.base_class.drivers
      // this.bus = data.base_class.cars.map(i => { return i.name }).join(',')
      this.remark = data.remark
      this.publisher = data.user_name
      this.approver = data.verify_info.truename
      this.handler = data.resource_name
      this.publisherId = data.user_id
      this.approverId = data.verify_info.id
      this.handlerId = data.resource_uid
      this.expandhandler = data.expand_username
      this.expandhandlerId = data.expand_uid
      this.equipments = data.sub_class
      this.statusNum = data.status
      this.expand_device_task_status = data.expand_device_task_status
      this.back_reason = data.back_reason
      this.status = data.status_name
      this.showUpload = (data.status == 2 || data.status == 3) && data.has_material_role
      this.topicDeleted = data.topic_is_delete == 1
      this.topicRole = data.has_topic_detail_role
    },
    goTopic(i) {
      if (this.topicDeleted || !this.topicRole) return

      this.$router.push({
        path: '/topicDetail',
        query: {
          d: i
        }
      })
    },
    goClue() {
      // 去创建线索页
      const d = {
        id: this.$route.query.r,
        title: this.title
      }

      dc.setItv(d)

      setTimeout(() => {
        dc.delItv()
      }, 0)

      common.jump('/creatClue', true)
    }
  },
  mounted() {
    this.defaultImg = this.$_syscfg.default_img
    this.checkType()
    this.getDetail()
    // this.getClues()
    // this.getHistory()
  },
  created() {
    common.goTop()
  }
}
</script>

<style lang="less" src="@assets/css/newTopic/interviewDetail.less" scoped></style>
